export const Campaign = {
	OBJECTIVE_LEADS: 2,
	OBJECTIVES: ['Events', 'Appointments', 'Leads', 'Downloads', 'Automation', 'Webinar'],
	OBJECTIVE_OPTIONS: [
		{ value: -1, text: 'Any' },
		{ value: 0, text: 'Events' },
		{ value: 1, text: 'Appointments' },
		{ value: 2, text: 'Leads' },
		{ value: 3, text: 'Downloads' },
		{ value: 4, text: 'Automation' },
		{ value: 5, text: 'Webinar' },
	],
	OBJECTIVE_EVENTS: 0,
	OBJECTIVE_APPOINTMENTS: 1,
	CALL_TO_ACTION_DEFAULTS: {
		'-1': '',
		'0': "You're exclusively invited to attend",
		'1': '',
		'2': '',
		'3': 'Download Our Complimentary Report',
		'4': '',
		'5': 'Watch Our Online Webinar',
	},
	IMAGE_BUCKET: 'leadjig-campaign-images',
	OBJECTIVE_NA: -1,
	OBJECTIVE_AUTOMATION: 4,
	OBJECTIVE_WEBINAR: 5,
	OBJECTIVE_DOWNLOAD: 3,
}
export const EmailReporting = {
	PROCESSED: 8,
	DROPPED: 2,
	BOUNCED: 3,
	COMPLAINED: 4,
	DELIVERED: 1,
	OPENED: 7,
	UNSUBSCRIBED: 5,
	CLICKED: 6,
	DEFERRED: 9,
	GROUP_UNSUBSCRIBED: 10,
	GROUP_RESUBSCRIBED: 11,
}
export const AnalyticsIntegration = { API: {} }
export const AnalyticsReport = {
	BUCKET: 'leadjig-reports/analytics',
	STATUS_NOT_STARTED: 'Not Started',
	STATUS_QUEUED: 'Queued',
	STATUS_PROCESSING: 'Processing',
	STATUS_UNAVAILABLE: 'Unavailable',
	STATUS_FAILED: 'Failed',
	STATUS_READY: 'Ready',
	PREFIX: 'development/analytics_report-',
}
export const Appointment = {
	DURATION_SELECT_OPTIONS: [
		['15 minutes', 900],
		['30 minutes', 1800],
		['45 minutes', 2700],
		['1 hour', 3600],
		['1 hour 30 minutes', 5400],
		['2 hours', 7200],
	],
	MINUTES_IN_YEAR: 525600,
	MINUTES_IN_QUARTER_YEAR: 131400,
	MINUTES_IN_THREE_QUARTERS_YEAR: 394200,
}
export const Attachment = { PREFIX: 'development/attachment-', BUCKET: 'leadjig-attachments' }
export const AttendeeRecord = {
	VERIFICATION_CONFIRMATION_CALL_STATUS_VOICEMAIL: 3,
	DIGITAL_CONFIRMATION_NA: 0,
	SOURCE_WEB: 1,
	CONFIRMATION_STATUS_VOICEMAIL: -2,
	RELATIONSHIP_SIGNIFICANT_OTHER: 2,
	RELATIONSHIP_OTHER: 0,
	RELATIONSHIP_SPOUSE: 1,
	RELATIONSHIP_OPTIONS: [
		{ text: 'Spouse', value: '1' },
		{ text: 'Significant Other', value: '2' },
		{ text: 'Family', value: '3' },
		{ text: 'Friend', value: '4' },
		{ text: 'Other relationship', value: '0' },
	],
	RELATIONSHIP_FAMILY: 3,
	RELATIONSHIP_FRIEND: 4,
	SOURCE_NA: 0,
	ATTENDED_PENDING: -1,
	CONFIRMATION_STATUS_PENDING: -1,
	CONFIRMATION_STATUS_CONFIRMED: 1,
	CONFIRMATION_STATUS_CANCELED: 0,
	CONFIRMATION_STATUS_CANCELED_GUEST: -3,
	ATTENDED_YES: 1,
	SOURCE_PHONE: 2,
	ATTENDED_NO: 0,
	VERIFICATION_STATUS_PENDING: -1,
	VERIFICATION_STATUS_NOT_INTERESTED: 0,
	VERIFICATION_STATUS_INTERESTED: 1,
	VERIFICATION_CONFIRMATION_CALL_STATUS_PENDING: -1,
	VERIFICATION_CONFIRMATION_CALL_STATUS_NOT_CONNECTED: 0,
	VERIFICATION_CONFIRMATION_CALL_STATUS_CONNECTED: 1,
	VERIFICATION_CONFIRMATION_CALL_STATUS_UNREACHABLE: 2,
}
export const Bucket = {
	BUCKETS: [
		'contacts',
		'contacts_registered_not_attended_event',
		'contacts_confirmed_not_attended_event',
		'contacts_attended_event',
		'contacts_with_appointments',
		'contacts_without_appointments',
		'contacts_attended_no_appointments',
		'contacts_attended_with_appointments',
		'contacts_with_status',
		'contacts_with_metadata',
	],
}
export const BucketRule = {
	FIELD_OPTIONS: {
		'attendee_records.confirmation_status': {
			options: { '-1': 'Pending', '1': 'Confirmed', '0': 'Canceled', '-3': 'Canceled Guest' },
			operators: ['equal', 'notEqual'],
			type: 'number',
		},
		'attendee_records.attended_status': {
			options: { '-1': 'Pending', '1': 'Attended', '0': 'No Show' },
			operators: ['equal', 'notEqual'],
			type: 'number',
		},
		'attendee_records.waitlisted': {
			options: { true: 'Waitlisted', false: 'Not Waitlisted' },
			operators: ['equal', 'notEqual'],
			type: 'boolean',
		},
		'attendee_records.source_medium': {
			options: { '1': 'Web', '2': 'Phone' },
			operators: ['equal', 'notEqual'],
			type: 'number',
		},
		'attendee_records.party_size': {
			operators: ['equal', 'notEqual', 'lessThan', 'lessThanInclusive', 'greaterThan', 'greaterThanInclusive'],
			input: 'number',
			type: 'number',
		},
		'attendee_records.paid': {
			options: { true: 'Paid', false: 'Not Paid' },
			operators: ['equal', 'notEqual'],
			type: 'boolean',
		},
		'contacts.email': { operators: ['equal', 'notEqual', 'contains', 'doesNotContain', 'matches'], input: 'text' },
		'attendee_records.created_at': {
			operators: ['lessThan', 'lessThanInclusive', 'greaterThan', 'greaterThanInclusive'],
			input: 'date',
		},
	},
	OPERATOR_SYMBOLS: {
		equal: '=',
		notEqual: '!=',
		in: 'in',
		notIn: 'not in',
		contains: 'contains',
		doesNotContain: 'does not contain',
		matches: 'matches',
		lessThan: '\u003c',
		lessThanInclusive: '\u003c=',
		greaterThan: '\u003e',
		greaterThanInclusive: '\u003e=',
	},
}
export const Contact = {
	COMMUNICATION_BLOCKED_UNTIL_DATE: 4,
	COMMUNICATION_BLOCKED_FOR_USER: 5,
	COMMUNICATION_UNSUBSCRIBED_BY_CONTACT: 2,
	COMMUNICATION_ALLOWED_BY_CONTACT: 3,
	COMMUNICATION_ALLOWED: 0,
	COMMUNICATION_BLOCKED: 1,
}
export const CalendarItem = { TYPE_APPOINTMENT: 2, TYPE_UNAVAILABLE: 0, TYPE_EVENT: 1, TYPE_EXTERNAL_EVENT: 3 }
export const ClientProduct = {
	PRODUCT_TYPE_ANNUITY: 0,
	PRODUCT_TYPE_LIFE: 4,
	PRODUCT_TYPE_AUM: 1,
	PRODUCT_TYPE_ESTATE: 2,
	PRODUCT_TYPE_INSURANCE: 3,
	PRODUCT_TYPE_MANAGED_MONEY: 5,
	FEE_TYPE_COMMISSION: 0,
	FEE_TYPE_FLAT: 1,
}
export const Creative = { APPROVAL_STATUS_PENDING: -1, APPROVAL_STATUS_DENIED: 0, APPROVAL_STATUS_APPROVED: 1 }
export const CustomNumberAccount = {
	APPLICATION: {
		friendly_name: 'LeadJig development',
		voice_url: null,
		voice_fallback_url: 'https://0i4ok7cr18.execute-api.us-east-1.amazonaws.com/dev/custom_numbers',
		sms_url: null,
	},
}
export const DynamicCampaign = { LURE_NAME: 'AGA Mail Drop' }
export const EmailTemplate = {
	EVENT_REGISTRATION: 2,
	EVENT_CANCELATION: 13,
	NOTIFICATION: 1,
	DIGITAL_REGISTRATION_CONFIRMATION: 17,
	CUSTOM_APPOINTMENT: -3,
	CUSTOM_EVENT: -2,
	CUSTOM_FOLLOW_UP: -4,
	PAYMENT_REQUEST: 12,
	APPOINTMENT_CONFIRMATION: 14,
	APPOINTMENT_RESCHEDULE: 15,
	SECOND_APPOINTMENT: 16,
	MERGE_PLACEHOLDERS: {
		subject: '[NOTIFICATION_TITLE]',
		unsubscribe_link: '[UNSUBSCRIBE_LINK]',
		user: {
			first_name: '[USER_FIRST_NAME]',
			last_name: '[USER_LAST_NAME]',
			full_name: '[USER_FULL_NAME]',
			email: '[USER_EMAIL_ADDRESS]',
			company_logo_url: '[COMPANY_LOGO]',
			company_name: '[COMPANY_NAME]',
			company_address_full: '[COMPANY_ADDRESS_FULL]',
			company_address_apt: '[COMPANY_ADDRESS_APT]',
			company_phone: '[COMPANY_PHONE]',
			company_phone_formatted: '[COMPANY_PHONE_FORMATTED]',
			company_email: '[COMPANY_EMAIL]',
			company_website: '[COMPANY_WEBSITE]',
			disclaimer: '[DISCLAIMER]',
		},
		notification: {
			link: '[NOTIFICATION_LINK]',
			output: { text: '[NOTIFICATION_MESSAGE]', icon: '[NOTIFICATION_ICON]' },
		},
		parameters: {
			contact: {
				first_name: '[CONTACT_FIRST_NAME]',
				last_name: '[CONTACT_LAST_NAME]',
				full_name: '[CONTACT_FULL_NAME]',
			},
			referral: {
				first_name: '[REFERRAL_FIRST_NAME]',
				last_name: '[REFERRAL_LAST_NAME]',
				full_name: '[REFERRAL_FULL_NAME]',
			},
			campaign: { id: '[CAMPAIGN_ID]' },
			event: {
				venue: '[EVENT_VENUE]',
				address_full: '[EVENT_ADDRESS_FULL]',
				start_time_formatted: '[EVENT_START_TIME]',
				hour_min_formatted: '[EVENT_TIME]',
				date_formatted: '[EVENT_DATE]',
				contact_cost: '[CONTACT_COST]',
				guest_cost: '[GUEST_COST]',
			},
			attendee_record: {
				id: '[ATTENDEE_RECORD_ID]',
				new_appointment_link: '[NEW_APPOINTMENT_LINK]',
				confirmation_link: '[CONFIRMATION_LINK]',
				cancelation_link: '[CANCELATION_LINK]',
				digital_registration_completion_link: '[DIGITAL_REGISTRATION_COMPLETION_LINK]',
				digital_registration_cancelation_link: '[DIGITAL_REGISTRATION_CANCELATION_LINK]',
				calendar_invite_file_url: '[CALENDAR_INVITE_FILE_URL]',
				payment_link: '[PAYMENT_LINK]',
				calendly_new_appointment_link: '[CALENDLY_NEW_APPOINTMENT_LINK]',
				calendly_reschedule_link: '[CALENDLY_RESCHEDULE_LINK]',
				calendly_cancelation_link: '[CALENDLY_CANCELATION_LINK]',
			},
			appointment: {
				start_time_formatted: '[APPOINTMENT_START_TIME]',
				end_time_formatted: '[APPOINTMENT_END_TIME]',
			},
			lure: { link: '[LURE_LINK]' },
		},
	},
	EVENT_WAITLIST: 3,
	EVENT_INVITATION: 4,
	EVENT_CONFIRMATION: 5,
	CUSTOM: -1,
	EVENT_THANK_YOU: 6,
	EVENT_NO_SHOW: 7,
	APPOINTMENT_REGISTRATION: 8,
	APPOINTMENT_THANK_YOU: 9,
	APPOINTMENT_NO_SHOW: 10,
	CONTACT_FOLLOW_UP: 11,
}
export const Feature = {
	RETARGETING: { id: 'RETARGETING' },
	ALWAYS_ON: { id: 'ALWAYS_ON' },
	AUTOMATION: { id: 'AUTOMATION' },
	WEB_ANALYTICS: { id: 'WEB_ANALYTICS' },
	BRAND_BOOST: { id: 'BRAND_BOOST' },
	LOCAL_SEO: { id: 'LOCAL_SEO' },
}
export const God = { MINUTES_IN_YEAR: 525600, MINUTES_IN_QUARTER_YEAR: 131400, MINUTES_IN_THREE_QUARTERS_YEAR: 394200 }
export const Integration = {
	LEAD_ADVANTAGE_PRO: 'lead_advantage_pro',
	REDTAIL: 'redtail',
	CALENDLY: 'calendly',
	FACEBOOK: 'facebook',
	GOOGLE_CALENDAR: 'google_calendar',
	WEALTHBOX: 'wealthbox',
	PIPEDRIVE: 'pipedrive',
}
export const LandingPage = {
	OBJECTIVE_LEADS: 'Leads',
	OBJECTIVE_DOWNLOADS: 'Downloads',
	OBJECTIVE_APPOINTMENTS: 'Appointments',
	MERGE_PLACEHOLDERS: { REGISTRATION_FORM_WIDGET: {}, CUSTOM_FORM_WIDGET: {} },
	OBJECTIVES: ['Appointments', 'Downloads', 'Leads', 'Events'],
	OBJECTIVE_EVENTS: 'Events',
}
export const LandingPageBackground = {
	PREFIX: 'development/landing-page-background-',
	BUCKET: 'leadjig-landing-page-backgrounds',
}
export const LandingPageConfig = {
	HIDE: 0,
	SHOW: 1,
	REQUIRED: 2,
	MODULE_DESCRIPTION: 'description',
	MODULE_DESCRIPTION_2: 'description2',
	MODULE_HIGHLIGHTS: 'highlights',
	MODULE_PROFILES: 'profiles',
	MODULE_COMPANY_INFO: 'company_info',
	MODULE_MAP: 'map',
	MODULE_CAROUSEL: 'carousel',
	MODULE_COUNTDOWN: 'countdown',
}
export const Lure = {
	CHANNEL_DIRECT_MAIL: 1,
	DEPLOYMENT_STATUS_READY: 0,
	DEPLOYMENT_STATUS_PENDING: -1,
	CHANNEL_EMAIL: 4,
	CHANNEL_INTERNAL: 5,
	CHANNEL_DIGITAL: 3,
	DEPLOYMENT_STATUS_DEPLOYED: 1,
	CHANNEL_RADIO: 2,
	DURATION_DIRECT_MAIL: 90,
	DURATION_RADIO: 180,
	DURATION_DIGITAL: 90,
	CHANNEL_CONTACT: 0,
	DURATION_EMAIL: 90,
}
export const Notification = { READ_VIEWED: 2, READ_NO: 0, READ_SEEN: 1 }
export const OptIn = {
	BLOCK_ALL_AUTOMATIONS: 4,
	EVENT_DEFAULT_NAME: 'LeadJig event communication opt-in',
	EVENT_DEFAULT: {
		id: '04451a6a-a7ca-43af-a6ce-0950290f65a9',
		user_id: null,
		text:
			'I understand that by registering for this event, I will receive emails or mail from [ADVISOR_NAME], such as a confirmation and reminder email. By checking this box, I authorize [ADVISOR_NAME] to occasionally send me additional educational and reminder emails. I can unsubscribe to communication from [ADVISOR_NAME] at any time and I also understand that the firm will not share or sell my information to anyone.',
		name: 'LeadJig event communication opt-in',
		global_default: true,
		created_at: '2021-05-10T20:06:33.809Z',
		updated_at: '2021-05-10T20:06:33.809Z',
	},
	MEDICARE_DEFAULT_NAME: 'LeadJig Medicare communication opt-in',
	MEDICARE_AND_EVENT_DEFAULT_NAME: 'LeadJig Medicare and event communication opt-in',
	MEDICARE_DEFAULT: {
		id: 'd2562c41-51e4-4334-be76-9c7975ff1ca7',
		user_id: null,
		text:
			'By checking this box I agree to have a licensed insurance agent call and/or email me about Medicare Advantage, Medicare Part D Prescription Drug Plans and/or Medicare Supplement insurance.',
		name: 'LeadJig Medicare communication opt-in',
		global_default: true,
		created_at: '2021-05-10T20:06:33.959Z',
		updated_at: '2021-05-10T20:06:33.959Z',
	},
	MEDICARE_AND_EVENT_DEFAULT: {
		id: 'b68df576-f517-42dd-ad15-974cd3d6f6d8',
		user_id: null,
		text:
			'By checking this box I agree to have a licensed insurance agent call and/or email me about Medicare Advantage, Medicare Part D Prescription Drug Plans and/or Medicare Supplement insurance.  I understand that by registering for this event, I will receive emails or mail from [ADVISOR_NAME], such as a confirmation and reminder email. By checking this box, I authorize [ADVISOR_NAME] to occasionally send me additional educational and reminder emails. I can unsubscribe to communication from [ADVISOR_NAME] at any time and I also understand that the firm will not share or sell my information to anyone.',
		name: 'LeadJig Medicare and event communication opt-in',
		global_default: true,
		created_at: '2021-05-10T20:06:33.962Z',
		updated_at: '2021-05-10T20:06:33.962Z',
	},
	REQUIRED: 1,
	NO_CHANGE: 0,
	BLOCK_ALL_COMMUNICATION: 2,
	BLOCK_CAMPAIGN_TOPIC: 3,
}
export const Report = {
	CONTACT_SPREADSHEET_UPLOAD: 'contact_spreadsheet_upload',
	BUCKET: 'leadjig-reports',
	CAMPAIGN_STATISTICS_REPORT: 'campaign_statistics_report',
	UPDATED_CONTACTS_REPORT: 'updated_contacts_report',
	CAMPAIGN_ATTENDEE_RECORDS_REPORT: 'campaign_attendee_records_report',
	CAMPAIGN_ANALYTICS: 'campaign_analytics',
	PREFIX: 'development/report-',
	CONTACT_EXPORT_REPORT: 'contact_export_report',
}
export const SalesforceAccount = { WEBHOOK_URL: '107.22.142.220:8000/webhook', API_VERSION: '42.0' }
export const Sequence = {
	CAMPAIGN_TYPE_STANDARD: 'STANDARD',
	CAMPAIGN_TYPE_AUTOMATION: 'AUTOMATION',
	REGISTRATION: 0,
	CONFIRMATION: 1,
	REMINDER: 2,
	AFTER: 3,
}
export const SequenceAction = {
	ACTION_EMAIL: 0,
	ACTION_SMS: 1,
	CONDITION_OPTIONS_STANDARD: {
		'attendee_record.confirmation_status': {
			options: { '-1': 'Pending', '1': 'Confirmed', '0': 'Canceled' },
			operators: ['equal', 'notEqual'],
			type: 'number',
		},
		'attendee_record.attended_status': {
			options: { '-1': 'Pending', '1': 'Attended', '0': 'No Show' },
			operators: ['equal', 'notEqual'],
			type: 'number',
		},
		'attendee_record.waitlisted': {
			options: { true: 'Waitlisted', false: 'Not Waitlisted' },
			operators: ['equal', 'notEqual'],
			type: 'boolean',
		},
		'attendee_record.source_medium': {
			options: { '1': 'Web', '2': 'Phone' },
			operators: ['equal', 'notEqual'],
			type: 'number',
		},
		'attendee_record.party_size': {
			operators: ['equal', 'notEqual', 'lessThan', 'lessThanInclusive', 'greaterThan', 'greaterThanInclusive'],
			input: 'number',
			type: 'number',
		},
		'attendee_record.paid': {
			options: { true: 'Paid', false: 'Not Paid' },
			operators: ['equal', 'notEqual'],
			type: 'boolean',
		},
		'attendee_record.has_future_appointment': {
			options: { true: 'Yes', false: 'No' },
			operators: ['equal', 'notEqual'],
			type: 'boolean',
		},
	},
	ACTION_VOICE: 2,
}
export const Sms = {
	INCOMING: 1,
	TEMPLATE_APPOINTMENT_CONFIRMATION: 3,
	TEMPLATE_EVENT_REMINDER: 2,
	TEMPLATE_EVENT_CONFIRMATION: 1,
	TEMPLATE_EVENT_CANCELATION: 5,
	TEMPLATE_APPOINTMENT_REMINDER: 4,
	TEMPLATE_DIGITAL_ALERT: 8,
	TEMPLATE_APPOINTMENT_CANCELATION: 6,
	TEMPLATE_DIGITAL_CONFIRMATION: 7,
	OUTGOING: 2,
}
export const SystemConfiguration = { SALESFORCE_CONSUMER_KEY: 'SALESFORCE_CONSUMER_KEY' }
export const Topic = {
	AUTOMATION_TOPICS: [
		{
			name: 'Retirement income \u0026 planning',
			value: 'retirement',
			topics: ['retirement', 'retirement_income_longevity', 'ss', 'annuities'],
		},
		{
			name: 'Investment',
			value: 'investment',
			topics: ['investment_money_management', 'real_estate', 'volatility', 'covid'],
		},
		{ name: 'IRA/401k', value: 'ira', topics: ['ira', 'rmd'] },
		{
			name: 'Medicare',
			value: 'medicare',
			topics: ['medicare', 'aga_open_enrollment', 'aga_t65', 'aga_dsnp', 'aga_recruitment'],
		},
		{ name: 'Life insurance', value: 'life_insurance', topics: ['life_insurance'] },
		{ name: "Women's finances", value: 'women', topics: ['women'] },
		{ name: 'Estate planning', value: 'estate', topics: ['estate'] },
		{ name: 'Taxes', value: 'taxes', topics: ['taxes', 'taxpro', 'trump', 'business_owners'] },
		{ name: 'Long term care', value: 'long_term_care', topics: ['long_term_care'] },
		{ name: 'Reverse mortgage', value: 'reverse_mortgage', topics: ['reverse_mortgage'] },
		{ name: 'College planning', value: 'college', topics: ['college'] },
		{
			name: 'Other',
			value: 'other',
			topics: [
				'no_topic',
				'client_event',
				'other',
				'teacherpro',
				'dinnerseminar',
				'radio',
				'default_appointment_setter',
				null,
				'',
			],
		},
	],
}
export const Webhook = { ACTIONS_DELETE: 'DELETE', ACTIONS_UPDATE: 'UPDATE', ACTIONS_CREATE: 'CREATE' }
export const YextAccount = {
	BRANDS: {
		GOOGLEMYBUSINESS: {
			id: 'GOOGLEMYBUSINESS',
			name: 'Google My Business',
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-250.svg',
		},
		ALEXA: { id: 'ALEXA', name: 'Amazon Alexa', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-359.svg' },
		APPLE: { id: 'APPLE', name: 'Apple', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-68.svg' },
		BING: { id: 'BING', name: 'Bing', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-24.svg' },
		FACEBOOK: {
			id: 'FACEBOOK',
			name: 'Facebook',
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-71.svg',
		},
		YELP: { id: 'YELP', name: 'Yelp', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-15.svg' },
		SNAPCHAT: {
			id: 'SNAPCHAT',
			name: 'Snapchat',
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-267.svg',
		},
		FOURSQUARE: {
			id: 'FOURSQUARE',
			name: 'Foursquare',
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-16.svg',
		},
		YAHOO: { id: 'YAHOO', name: 'Yahoo!', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-19.svg' },
		MERCHANTCIRCLE: { name: 'MerchantCircle', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-6.svg' },
		CITYSEARCH: { name: 'Citysearch', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-7.svg' },
		MAPQUEST: { name: 'MapQuest', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-9.svg' },
		TELENAV: { name: 'TeleNav', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-11.svg' },
		SUPERPAGES: { name: 'Superpages', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-13.svg' },
		SHOWMELOCAL: { name: 'ShowMeLocal', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-23.svg' },
		TUPALO: { name: 'Tupalo', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-30.svg' },
		YELLOWMOXIE: { name: 'YellowMoxie', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-32.svg' },
		AVANTAR: { name: 'Avantar', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-35.svg' },
		LOCALPAGES: { name: 'LocalPages', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-39.svg' },
		WHERETO: { name: 'Where To?', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-43.svg' },
		CITYSQUARES: { name: 'CitySquares', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-44.svg' },
		NAVMII: { name: 'Navmii', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-47.svg' },
		USCITYNET: { name: 'USCity.net', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-57.svg' },
		YELLOWPAGECITYCOM: {
			name: 'YellowPageCity.com',
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-58.svg',
		},
		CHAMBEROFCOMMERCECOM: {
			name: 'ChamberofCommerce.com',
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-59.svg',
		},
		'8COUPONS': { name: '8coupons', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-60.svg' },
		FACTUAL: { name: 'Factual', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-61.svg' },
		AMERICANTOWNSCOM: {
			name: 'AmericanTowns.com',
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-63.svg',
		},
		ELOCAL: { name: 'eLocal', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-64.svg' },
		YPCOM: { name: 'YP.com', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-65.svg' },
		YASABE: { name: 'YaSabe', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-74.svg' },
		GOLOCAL247: { name: 'GoLocal247', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-75.svg' },
		HERE: { name: 'HERE', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-85.svg' },
		YELLOWPAGESGOESGREEN: {
			name: 'YellowPagesDirectory',
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-81.svg',
		},
		POINTCOM: { name: 'Pointcom', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-83.svg' },
		ABLOCAL: { name: 'ABLocal', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-84.svg' },
		OPENDI: { name: 'Opendi', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-86.svg' },
		VOTEFORTHEBEST: { name: 'VotefortheBest', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-87.svg' },
		'2FINDLOCAL': { name: '2findlocal', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-89.svg' },
		TOMTOM: { name: 'TomTom', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-93.svg' },
		EXTERNALFIRSTPARTY: { name: 'External First Party', icon: '' },
		YELPENTERPRISE: { name: 'Yelp Enterprise', icon: '' },
		MYLOCALSERVICES: {
			name: 'My Local Services',
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-95.svg',
		},
		N49CA: { name: 'n49', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-100.svg' },
		YANDEX: { name: 'Yandex', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-136.svg' },
		CYLEX: { name: 'Cylex', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-135.svg' },
		IBEGIN: { name: 'iBegin', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-163.svg' },
		IGLOBAL: { name: 'iGlobal', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-159.svg' },
		CREDIBILITYREVIEW: {
			name: 'Credibility Review',
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-178.svg',
		},
		INSIDERPAGES: { name: 'Insider Pages', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-187.svg' },
		LOCALSTACK: { name: 'LocalStack', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-184.svg' },
		YALWA: { name: 'Yalwa', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-209.svg' },
		BROWNBOOKNET: { name: 'Brownbook.net', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-214.svg' },
		BIZWIKICOM: { name: 'Bizwiki.com', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-219.svg' },
		SOLEO: { name: 'Soleo', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-223.svg' },
		AROUNDME: { name: 'AroundMe', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-251.svg' },
		HOTFROG: { name: 'HotFrog', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-258.svg' },
		EZLOCAL: { name: 'EZlocal', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-272.svg' },
		FIRSTPARTY: { name: 'First Party', icon: '' },
		LOCALDATABASE: { name: 'LocalDatabase', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-304.svg' },
		PUBLICREPUTATION: { name: 'pr.business', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-310.svg' },
		FINDOPEN: { name: 'Find Open', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-311.svg' },
		TRIPADVISORREVIEWS: { name: 'TripAdvisor', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-312.svg' },
		CKMAPS: { name: 'CK Map', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-314.svg' },
		UBER: { name: 'Uber', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-318.svg' },
		ZOMATO: { name: 'Zomato', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-337.svg' },
		POSTMATES: { name: 'Postmates', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-338.svg' },
		YELPKNOWLEDGE: { name: 'Yelp Knowledge', icon: '' },
		BAIDUGLOBAL: { name: 'Baidu', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-348.svg' },
		BANKSCOM: { name: 'Banks.com', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-360.svg' },
		DUNANDBRADSTREET: {
			name: 'D\u0026B Database',
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-363.svg',
		},
		FEIZHU: { name: 'Fliggy', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-364.svg' },
		PITNEYBOWES: { name: 'Pitney Bowes', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-365.svg' },
		PROPERTYCAPSULE: {
			name: 'Property Capsule',
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-369.svg',
		},
		LOCALCOM: { name: 'Local.com v2', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-370.svg' },
		TRUSTPILOT: { name: 'TrustPilot', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-379.svg' },
		HOLIDAYCHECK: { name: 'HolidayCheck', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-399.svg' },
		DOORDASH: { name: 'DoorDash', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-406.svg' },
		NEXTDOOR: { name: 'Nextdoor', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-408.svg' },
		OPENTABLE: { name: 'OpenTable', icon: '' },
		MAFENGWO: { name: 'Mafengwo', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-415.svg' },
		TOPRATEDLOCAL: { name: 'Top Rated Local', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-416.svg' },
		TRIP: { name: 'Trip.com', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-418.svg' },
		RETIREMENTPLANNINGNET: {
			name: 'RetirementPlanning.net',
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-423.svg',
		},
		HOSTME: { name: 'HostMe', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-427.svg' },
		CENTRALINDEXUS: { name: 'Central Index US', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-97.svg' },
		MAPSTR: { name: 'Mapstr', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-422.svg' },
		DexKnows: { icon: 'https://www.yext-static.com/cms/spark/1/site-icon-248.svg', name: 'DexKnows' },
		Instagram: { icon: 'https://www.yext-static.com/cms/spark/1/site-icon-405.svg', name: 'Instagram' },
		Waze: { icon: 'https://www.yext-static.com/cms/spark/1/site-icon-255.svg', name: 'Waze' },
		'White \u0026 Yellow Pages': {
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-70.svg',
			name: 'White \u0026 Yellow Pages',
		},
		AirYell: { icon: 'https://www.yext-static.com/cms/spark/1/site-icon-69.svg', name: 'AirYell' },
		WiserAdvisor: { icon: 'https://www.yext-static.com/cms/spark/1/site-icon-435.svg', name: 'WiserAdvisor' },
		Allonesearch: { icon: 'https://www.yext-static.com/cms/spark/1/site-icon-233.svg', name: 'Allonesearch' },
		'The Internet Chamber of Commerce': {
			icon: 'https://www.yext-static.com/cms/spark/1/site-icon-232.svg',
			name: 'The Internet Chamber of Commerce',
		},
	},
}
export const Mutations = { UPDATE: 1, RESTORE: 3, DESTROY: 2, COPY: 4, CREATE: 0 }
export default {
	Campaign: {
		OBJECTIVE_LEADS: 2,
		OBJECTIVES: ['Events', 'Appointments', 'Leads', 'Downloads', 'Automation', 'Webinar'],
		OBJECTIVE_OPTIONS: [
			{ value: -1, text: 'Any' },
			{ value: 0, text: 'Events' },
			{ value: 1, text: 'Appointments' },
			{ value: 2, text: 'Leads' },
			{ value: 3, text: 'Downloads' },
			{ value: 4, text: 'Automation' },
			{ value: 5, text: 'Webinar' },
		],
		OBJECTIVE_EVENTS: 0,
		OBJECTIVE_APPOINTMENTS: 1,
		CALL_TO_ACTION_DEFAULTS: {
			'-1': '',
			'0': "You're exclusively invited to attend",
			'1': '',
			'2': '',
			'3': 'Download Our Complimentary Report',
			'4': '',
			'5': 'Watch Our Online Webinar',
		},
		IMAGE_BUCKET: 'leadjig-campaign-images',
		OBJECTIVE_NA: -1,
		OBJECTIVE_AUTOMATION: 4,
		OBJECTIVE_WEBINAR: 5,
		OBJECTIVE_DOWNLOAD: 3,
	},
	EmailReporting: {
		PROCESSED: 8,
		DROPPED: 2,
		BOUNCED: 3,
		COMPLAINED: 4,
		DELIVERED: 1,
		OPENED: 7,
		UNSUBSCRIBED: 5,
		CLICKED: 6,
		DEFERRED: 9,
		GROUP_UNSUBSCRIBED: 10,
		GROUP_RESUBSCRIBED: 11,
	},
	AnalyticsIntegration: { API: {} },
	AnalyticsReport: {
		BUCKET: 'leadjig-reports/analytics',
		STATUS_NOT_STARTED: 'Not Started',
		STATUS_QUEUED: 'Queued',
		STATUS_PROCESSING: 'Processing',
		STATUS_UNAVAILABLE: 'Unavailable',
		STATUS_FAILED: 'Failed',
		STATUS_READY: 'Ready',
		PREFIX: 'development/analytics_report-',
	},
	Appointment: {
		DURATION_SELECT_OPTIONS: [
			['15 minutes', 900],
			['30 minutes', 1800],
			['45 minutes', 2700],
			['1 hour', 3600],
			['1 hour 30 minutes', 5400],
			['2 hours', 7200],
		],
		MINUTES_IN_YEAR: 525600,
		MINUTES_IN_QUARTER_YEAR: 131400,
		MINUTES_IN_THREE_QUARTERS_YEAR: 394200,
	},
	Attachment: { PREFIX: 'development/attachment-', BUCKET: 'leadjig-attachments' },
	AttendeeRecord: {
		VERIFICATION_CONFIRMATION_CALL_STATUS_VOICEMAIL: 3,
		DIGITAL_CONFIRMATION_NA: 0,
		SOURCE_WEB: 1,
		CONFIRMATION_STATUS_VOICEMAIL: -2,
		RELATIONSHIP_SIGNIFICANT_OTHER: 2,
		RELATIONSHIP_OTHER: 0,
		RELATIONSHIP_SPOUSE: 1,
		RELATIONSHIP_OPTIONS: [
			{ text: 'Spouse', value: '1' },
			{ text: 'Significant Other', value: '2' },
			{ text: 'Family', value: '3' },
			{ text: 'Friend', value: '4' },
			{ text: 'Other relationship', value: '0' },
		],
		RELATIONSHIP_FAMILY: 3,
		RELATIONSHIP_FRIEND: 4,
		SOURCE_NA: 0,
		ATTENDED_PENDING: -1,
		CONFIRMATION_STATUS_PENDING: -1,
		CONFIRMATION_STATUS_CONFIRMED: 1,
		CONFIRMATION_STATUS_CANCELED: 0,
		CONFIRMATION_STATUS_CANCELED_GUEST: -3,
		ATTENDED_YES: 1,
		SOURCE_PHONE: 2,
		ATTENDED_NO: 0,
		VERIFICATION_STATUS_PENDING: -1,
		VERIFICATION_STATUS_NOT_INTERESTED: 0,
		VERIFICATION_STATUS_INTERESTED: 1,
		VERIFICATION_CONFIRMATION_CALL_STATUS_PENDING: -1,
		VERIFICATION_CONFIRMATION_CALL_STATUS_NOT_CONNECTED: 0,
		VERIFICATION_CONFIRMATION_CALL_STATUS_CONNECTED: 1,
		VERIFICATION_CONFIRMATION_CALL_STATUS_UNREACHABLE: 2,
	},
	Bucket: {
		BUCKETS: [
			'contacts',
			'contacts_registered_not_attended_event',
			'contacts_confirmed_not_attended_event',
			'contacts_attended_event',
			'contacts_with_appointments',
			'contacts_without_appointments',
			'contacts_attended_no_appointments',
			'contacts_attended_with_appointments',
			'contacts_with_status',
			'contacts_with_metadata',
		],
	},
	BucketRule: {
		FIELD_OPTIONS: {
			'attendee_records.confirmation_status': {
				options: { '-1': 'Pending', '1': 'Confirmed', '0': 'Canceled', '-3': 'Canceled Guest' },
				operators: ['equal', 'notEqual'],
				type: 'number',
			},
			'attendee_records.attended_status': {
				options: { '-1': 'Pending', '1': 'Attended', '0': 'No Show' },
				operators: ['equal', 'notEqual'],
				type: 'number',
			},
			'attendee_records.waitlisted': {
				options: { true: 'Waitlisted', false: 'Not Waitlisted' },
				operators: ['equal', 'notEqual'],
				type: 'boolean',
			},
			'attendee_records.source_medium': {
				options: { '1': 'Web', '2': 'Phone' },
				operators: ['equal', 'notEqual'],
				type: 'number',
			},
			'attendee_records.party_size': {
				operators: [
					'equal',
					'notEqual',
					'lessThan',
					'lessThanInclusive',
					'greaterThan',
					'greaterThanInclusive',
				],
				input: 'number',
				type: 'number',
			},
			'attendee_records.paid': {
				options: { true: 'Paid', false: 'Not Paid' },
				operators: ['equal', 'notEqual'],
				type: 'boolean',
			},
			'contacts.email': {
				operators: ['equal', 'notEqual', 'contains', 'doesNotContain', 'matches'],
				input: 'text',
			},
			'attendee_records.created_at': {
				operators: ['lessThan', 'lessThanInclusive', 'greaterThan', 'greaterThanInclusive'],
				input: 'date',
			},
		},
		OPERATOR_SYMBOLS: {
			equal: '=',
			notEqual: '!=',
			in: 'in',
			notIn: 'not in',
			contains: 'contains',
			doesNotContain: 'does not contain',
			matches: 'matches',
			lessThan: '\u003c',
			lessThanInclusive: '\u003c=',
			greaterThan: '\u003e',
			greaterThanInclusive: '\u003e=',
		},
	},
	Contact: {
		COMMUNICATION_BLOCKED_UNTIL_DATE: 4,
		COMMUNICATION_BLOCKED_FOR_USER: 5,
		COMMUNICATION_UNSUBSCRIBED_BY_CONTACT: 2,
		COMMUNICATION_ALLOWED_BY_CONTACT: 3,
		COMMUNICATION_ALLOWED: 0,
		COMMUNICATION_BLOCKED: 1,
	},
	CalendarItem: { TYPE_APPOINTMENT: 2, TYPE_UNAVAILABLE: 0, TYPE_EVENT: 1, TYPE_EXTERNAL_EVENT: 3 },
	ClientProduct: {
		PRODUCT_TYPE_ANNUITY: 0,
		PRODUCT_TYPE_LIFE: 4,
		PRODUCT_TYPE_AUM: 1,
		PRODUCT_TYPE_ESTATE: 2,
		PRODUCT_TYPE_INSURANCE: 3,
		PRODUCT_TYPE_MANAGED_MONEY: 5,
		FEE_TYPE_COMMISSION: 0,
		FEE_TYPE_FLAT: 1,
	},
	Creative: { APPROVAL_STATUS_PENDING: -1, APPROVAL_STATUS_DENIED: 0, APPROVAL_STATUS_APPROVED: 1 },
	CustomNumberAccount: {
		APPLICATION: {
			friendly_name: 'LeadJig development',
			voice_url: null,
			voice_fallback_url: 'https://0i4ok7cr18.execute-api.us-east-1.amazonaws.com/dev/custom_numbers',
			sms_url: null,
		},
	},
	DynamicCampaign: { LURE_NAME: 'AGA Mail Drop' },
	EmailTemplate: {
		EVENT_REGISTRATION: 2,
		EVENT_CANCELATION: 13,
		NOTIFICATION: 1,
		DIGITAL_REGISTRATION_CONFIRMATION: 17,
		CUSTOM_APPOINTMENT: -3,
		CUSTOM_EVENT: -2,
		CUSTOM_FOLLOW_UP: -4,
		PAYMENT_REQUEST: 12,
		APPOINTMENT_CONFIRMATION: 14,
		APPOINTMENT_RESCHEDULE: 15,
		SECOND_APPOINTMENT: 16,
		MERGE_PLACEHOLDERS: {
			subject: '[NOTIFICATION_TITLE]',
			unsubscribe_link: '[UNSUBSCRIBE_LINK]',
			user: {
				first_name: '[USER_FIRST_NAME]',
				last_name: '[USER_LAST_NAME]',
				full_name: '[USER_FULL_NAME]',
				email: '[USER_EMAIL_ADDRESS]',
				company_logo_url: '[COMPANY_LOGO]',
				company_name: '[COMPANY_NAME]',
				company_address_full: '[COMPANY_ADDRESS_FULL]',
				company_address_apt: '[COMPANY_ADDRESS_APT]',
				company_phone: '[COMPANY_PHONE]',
				company_phone_formatted: '[COMPANY_PHONE_FORMATTED]',
				company_email: '[COMPANY_EMAIL]',
				company_website: '[COMPANY_WEBSITE]',
				disclaimer: '[DISCLAIMER]',
			},
			notification: {
				link: '[NOTIFICATION_LINK]',
				output: { text: '[NOTIFICATION_MESSAGE]', icon: '[NOTIFICATION_ICON]' },
			},
			parameters: {
				contact: {
					first_name: '[CONTACT_FIRST_NAME]',
					last_name: '[CONTACT_LAST_NAME]',
					full_name: '[CONTACT_FULL_NAME]',
				},
				referral: {
					first_name: '[REFERRAL_FIRST_NAME]',
					last_name: '[REFERRAL_LAST_NAME]',
					full_name: '[REFERRAL_FULL_NAME]',
				},
				campaign: { id: '[CAMPAIGN_ID]' },
				event: {
					venue: '[EVENT_VENUE]',
					address_full: '[EVENT_ADDRESS_FULL]',
					start_time_formatted: '[EVENT_START_TIME]',
					hour_min_formatted: '[EVENT_TIME]',
					date_formatted: '[EVENT_DATE]',
					contact_cost: '[CONTACT_COST]',
					guest_cost: '[GUEST_COST]',
				},
				attendee_record: {
					id: '[ATTENDEE_RECORD_ID]',
					new_appointment_link: '[NEW_APPOINTMENT_LINK]',
					confirmation_link: '[CONFIRMATION_LINK]',
					cancelation_link: '[CANCELATION_LINK]',
					digital_registration_completion_link: '[DIGITAL_REGISTRATION_COMPLETION_LINK]',
					digital_registration_cancelation_link: '[DIGITAL_REGISTRATION_CANCELATION_LINK]',
					calendar_invite_file_url: '[CALENDAR_INVITE_FILE_URL]',
					payment_link: '[PAYMENT_LINK]',
					calendly_new_appointment_link: '[CALENDLY_NEW_APPOINTMENT_LINK]',
					calendly_reschedule_link: '[CALENDLY_RESCHEDULE_LINK]',
					calendly_cancelation_link: '[CALENDLY_CANCELATION_LINK]',
				},
				appointment: {
					start_time_formatted: '[APPOINTMENT_START_TIME]',
					end_time_formatted: '[APPOINTMENT_END_TIME]',
				},
				lure: { link: '[LURE_LINK]' },
			},
		},
		EVENT_WAITLIST: 3,
		EVENT_INVITATION: 4,
		EVENT_CONFIRMATION: 5,
		CUSTOM: -1,
		EVENT_THANK_YOU: 6,
		EVENT_NO_SHOW: 7,
		APPOINTMENT_REGISTRATION: 8,
		APPOINTMENT_THANK_YOU: 9,
		APPOINTMENT_NO_SHOW: 10,
		CONTACT_FOLLOW_UP: 11,
	},
	Feature: {
		RETARGETING: { id: 'RETARGETING' },
		ALWAYS_ON: { id: 'ALWAYS_ON' },
		AUTOMATION: { id: 'AUTOMATION' },
		WEB_ANALYTICS: { id: 'WEB_ANALYTICS' },
		BRAND_BOOST: { id: 'BRAND_BOOST' },
		LOCAL_SEO: { id: 'LOCAL_SEO' },
	},
	God: { MINUTES_IN_YEAR: 525600, MINUTES_IN_QUARTER_YEAR: 131400, MINUTES_IN_THREE_QUARTERS_YEAR: 394200 },
	Integration: {
		LEAD_ADVANTAGE_PRO: 'lead_advantage_pro',
		REDTAIL: 'redtail',
		CALENDLY: 'calendly',
		FACEBOOK: 'facebook',
		GOOGLE_CALENDAR: 'google_calendar',
		WEALTHBOX: 'wealthbox',
		PIPEDRIVE: 'pipedrive',
	},
	LandingPage: {
		OBJECTIVE_LEADS: 'Leads',
		OBJECTIVE_DOWNLOADS: 'Downloads',
		OBJECTIVE_APPOINTMENTS: 'Appointments',
		MERGE_PLACEHOLDERS: { REGISTRATION_FORM_WIDGET: {}, CUSTOM_FORM_WIDGET: {} },
		OBJECTIVES: ['Appointments', 'Downloads', 'Leads', 'Events'],
		OBJECTIVE_EVENTS: 'Events',
	},
	LandingPageBackground: {
		PREFIX: 'development/landing-page-background-',
		BUCKET: 'leadjig-landing-page-backgrounds',
	},
	LandingPageConfig: {
		HIDE: 0,
		SHOW: 1,
		REQUIRED: 2,
		MODULE_DESCRIPTION: 'description',
		MODULE_DESCRIPTION_2: 'description2',
		MODULE_HIGHLIGHTS: 'highlights',
		MODULE_PROFILES: 'profiles',
		MODULE_COMPANY_INFO: 'company_info',
		MODULE_MAP: 'map',
		MODULE_CAROUSEL: 'carousel',
		MODULE_COUNTDOWN: 'countdown',
	},
	Lure: {
		CHANNEL_DIRECT_MAIL: 1,
		DEPLOYMENT_STATUS_READY: 0,
		DEPLOYMENT_STATUS_PENDING: -1,
		CHANNEL_EMAIL: 4,
		CHANNEL_INTERNAL: 5,
		CHANNEL_DIGITAL: 3,
		DEPLOYMENT_STATUS_DEPLOYED: 1,
		CHANNEL_RADIO: 2,
		DURATION_DIRECT_MAIL: 90,
		DURATION_RADIO: 180,
		DURATION_DIGITAL: 90,
		CHANNEL_CONTACT: 0,
		DURATION_EMAIL: 90,
	},
	Notification: { READ_VIEWED: 2, READ_NO: 0, READ_SEEN: 1 },
	OptIn: {
		BLOCK_ALL_AUTOMATIONS: 4,
		EVENT_DEFAULT_NAME: 'LeadJig event communication opt-in',
		EVENT_DEFAULT: {
			id: '04451a6a-a7ca-43af-a6ce-0950290f65a9',
			user_id: null,
			text:
				'I understand that by registering for this event, I will receive emails or mail from [ADVISOR_NAME], such as a confirmation and reminder email. By checking this box, I authorize [ADVISOR_NAME] to occasionally send me additional educational and reminder emails. I can unsubscribe to communication from [ADVISOR_NAME] at any time and I also understand that the firm will not share or sell my information to anyone.',
			name: 'LeadJig event communication opt-in',
			global_default: true,
			created_at: '2021-05-10T20:06:33.809Z',
			updated_at: '2021-05-10T20:06:33.809Z',
		},
		MEDICARE_DEFAULT_NAME: 'LeadJig Medicare communication opt-in',
		MEDICARE_AND_EVENT_DEFAULT_NAME: 'LeadJig Medicare and event communication opt-in',
		MEDICARE_DEFAULT: {
			id: 'd2562c41-51e4-4334-be76-9c7975ff1ca7',
			user_id: null,
			text:
				'By checking this box I agree to have a licensed insurance agent call and/or email me about Medicare Advantage, Medicare Part D Prescription Drug Plans and/or Medicare Supplement insurance.',
			name: 'LeadJig Medicare communication opt-in',
			global_default: true,
			created_at: '2021-05-10T20:06:33.959Z',
			updated_at: '2021-05-10T20:06:33.959Z',
		},
		MEDICARE_AND_EVENT_DEFAULT: {
			id: 'b68df576-f517-42dd-ad15-974cd3d6f6d8',
			user_id: null,
			text:
				'By checking this box I agree to have a licensed insurance agent call and/or email me about Medicare Advantage, Medicare Part D Prescription Drug Plans and/or Medicare Supplement insurance.  I understand that by registering for this event, I will receive emails or mail from [ADVISOR_NAME], such as a confirmation and reminder email. By checking this box, I authorize [ADVISOR_NAME] to occasionally send me additional educational and reminder emails. I can unsubscribe to communication from [ADVISOR_NAME] at any time and I also understand that the firm will not share or sell my information to anyone.',
			name: 'LeadJig Medicare and event communication opt-in',
			global_default: true,
			created_at: '2021-05-10T20:06:33.962Z',
			updated_at: '2021-05-10T20:06:33.962Z',
		},
		REQUIRED: 1,
		NO_CHANGE: 0,
		BLOCK_ALL_COMMUNICATION: 2,
		BLOCK_CAMPAIGN_TOPIC: 3,
	},
	Report: {
		CONTACT_SPREADSHEET_UPLOAD: 'contact_spreadsheet_upload',
		BUCKET: 'leadjig-reports',
		CAMPAIGN_STATISTICS_REPORT: 'campaign_statistics_report',
		UPDATED_CONTACTS_REPORT: 'updated_contacts_report',
		CAMPAIGN_ATTENDEE_RECORDS_REPORT: 'campaign_attendee_records_report',
		CAMPAIGN_ANALYTICS: 'campaign_analytics',
		PREFIX: 'development/report-',
		CONTACT_EXPORT_REPORT: 'contact_export_report',
	},
	SalesforceAccount: { WEBHOOK_URL: '107.22.142.220:8000/webhook', API_VERSION: '42.0' },
	Sequence: {
		CAMPAIGN_TYPE_STANDARD: 'STANDARD',
		CAMPAIGN_TYPE_AUTOMATION: 'AUTOMATION',
		REGISTRATION: 0,
		CONFIRMATION: 1,
		REMINDER: 2,
		AFTER: 3,
	},
	SequenceAction: {
		ACTION_EMAIL: 0,
		ACTION_SMS: 1,
		CONDITION_OPTIONS_STANDARD: {
			'attendee_record.confirmation_status': {
				options: { '-1': 'Pending', '1': 'Confirmed', '0': 'Canceled' },
				operators: ['equal', 'notEqual'],
				type: 'number',
			},
			'attendee_record.attended_status': {
				options: { '-1': 'Pending', '1': 'Attended', '0': 'No Show' },
				operators: ['equal', 'notEqual'],
				type: 'number',
			},
			'attendee_record.waitlisted': {
				options: { true: 'Waitlisted', false: 'Not Waitlisted' },
				operators: ['equal', 'notEqual'],
				type: 'boolean',
			},
			'attendee_record.source_medium': {
				options: { '1': 'Web', '2': 'Phone' },
				operators: ['equal', 'notEqual'],
				type: 'number',
			},
			'attendee_record.party_size': {
				operators: [
					'equal',
					'notEqual',
					'lessThan',
					'lessThanInclusive',
					'greaterThan',
					'greaterThanInclusive',
				],
				input: 'number',
				type: 'number',
			},
			'attendee_record.paid': {
				options: { true: 'Paid', false: 'Not Paid' },
				operators: ['equal', 'notEqual'],
				type: 'boolean',
			},
			'attendee_record.has_future_appointment': {
				options: { true: 'Yes', false: 'No' },
				operators: ['equal', 'notEqual'],
				type: 'boolean',
			},
		},
		ACTION_VOICE: 2,
	},
	Sms: {
		INCOMING: 1,
		TEMPLATE_APPOINTMENT_CONFIRMATION: 3,
		TEMPLATE_EVENT_REMINDER: 2,
		TEMPLATE_EVENT_CONFIRMATION: 1,
		TEMPLATE_EVENT_CANCELATION: 5,
		TEMPLATE_APPOINTMENT_REMINDER: 4,
		TEMPLATE_DIGITAL_ALERT: 8,
		TEMPLATE_APPOINTMENT_CANCELATION: 6,
		TEMPLATE_DIGITAL_CONFIRMATION: 7,
		OUTGOING: 2,
	},
	SystemConfiguration: { SALESFORCE_CONSUMER_KEY: 'SALESFORCE_CONSUMER_KEY' },
	Topic: {
		AUTOMATION_TOPICS: [
			{
				name: 'Retirement income \u0026 planning',
				value: 'retirement',
				topics: ['retirement', 'retirement_income_longevity', 'ss', 'annuities'],
			},
			{
				name: 'Investment',
				value: 'investment',
				topics: ['investment_money_management', 'real_estate', 'volatility', 'covid'],
			},
			{ name: 'IRA/401k', value: 'ira', topics: ['ira', 'rmd'] },
			{
				name: 'Medicare',
				value: 'medicare',
				topics: ['medicare', 'aga_open_enrollment', 'aga_t65', 'aga_dsnp', 'aga_recruitment'],
			},
			{ name: 'Life insurance', value: 'life_insurance', topics: ['life_insurance'] },
			{ name: "Women's finances", value: 'women', topics: ['women'] },
			{ name: 'Estate planning', value: 'estate', topics: ['estate'] },
			{ name: 'Taxes', value: 'taxes', topics: ['taxes', 'taxpro', 'trump', 'business_owners'] },
			{ name: 'Long term care', value: 'long_term_care', topics: ['long_term_care'] },
			{ name: 'Reverse mortgage', value: 'reverse_mortgage', topics: ['reverse_mortgage'] },
			{ name: 'College planning', value: 'college', topics: ['college'] },
			{
				name: 'Other',
				value: 'other',
				topics: [
					'no_topic',
					'client_event',
					'other',
					'teacherpro',
					'dinnerseminar',
					'radio',
					'default_appointment_setter',
					null,
					'',
				],
			},
		],
	},
	Webhook: { ACTIONS_DELETE: 'DELETE', ACTIONS_UPDATE: 'UPDATE', ACTIONS_CREATE: 'CREATE' },
	YextAccount: {
		BRANDS: {
			GOOGLEMYBUSINESS: {
				id: 'GOOGLEMYBUSINESS',
				name: 'Google My Business',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-250.svg',
			},
			ALEXA: {
				id: 'ALEXA',
				name: 'Amazon Alexa',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-359.svg',
			},
			APPLE: { id: 'APPLE', name: 'Apple', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-68.svg' },
			BING: { id: 'BING', name: 'Bing', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-24.svg' },
			FACEBOOK: {
				id: 'FACEBOOK',
				name: 'Facebook',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-71.svg',
			},
			YELP: { id: 'YELP', name: 'Yelp', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-15.svg' },
			SNAPCHAT: {
				id: 'SNAPCHAT',
				name: 'Snapchat',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-267.svg',
			},
			FOURSQUARE: {
				id: 'FOURSQUARE',
				name: 'Foursquare',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-16.svg',
			},
			YAHOO: { id: 'YAHOO', name: 'Yahoo!', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-19.svg' },
			MERCHANTCIRCLE: { name: 'MerchantCircle', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-6.svg' },
			CITYSEARCH: { name: 'Citysearch', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-7.svg' },
			MAPQUEST: { name: 'MapQuest', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-9.svg' },
			TELENAV: { name: 'TeleNav', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-11.svg' },
			SUPERPAGES: { name: 'Superpages', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-13.svg' },
			SHOWMELOCAL: { name: 'ShowMeLocal', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-23.svg' },
			TUPALO: { name: 'Tupalo', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-30.svg' },
			YELLOWMOXIE: { name: 'YellowMoxie', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-32.svg' },
			AVANTAR: { name: 'Avantar', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-35.svg' },
			LOCALPAGES: { name: 'LocalPages', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-39.svg' },
			WHERETO: { name: 'Where To?', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-43.svg' },
			CITYSQUARES: { name: 'CitySquares', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-44.svg' },
			NAVMII: { name: 'Navmii', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-47.svg' },
			USCITYNET: { name: 'USCity.net', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-57.svg' },
			YELLOWPAGECITYCOM: {
				name: 'YellowPageCity.com',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-58.svg',
			},
			CHAMBEROFCOMMERCECOM: {
				name: 'ChamberofCommerce.com',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-59.svg',
			},
			'8COUPONS': { name: '8coupons', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-60.svg' },
			FACTUAL: { name: 'Factual', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-61.svg' },
			AMERICANTOWNSCOM: {
				name: 'AmericanTowns.com',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-63.svg',
			},
			ELOCAL: { name: 'eLocal', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-64.svg' },
			YPCOM: { name: 'YP.com', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-65.svg' },
			YASABE: { name: 'YaSabe', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-74.svg' },
			GOLOCAL247: { name: 'GoLocal247', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-75.svg' },
			HERE: { name: 'HERE', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-85.svg' },
			YELLOWPAGESGOESGREEN: {
				name: 'YellowPagesDirectory',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-81.svg',
			},
			POINTCOM: { name: 'Pointcom', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-83.svg' },
			ABLOCAL: { name: 'ABLocal', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-84.svg' },
			OPENDI: { name: 'Opendi', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-86.svg' },
			VOTEFORTHEBEST: {
				name: 'VotefortheBest',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-87.svg',
			},
			'2FINDLOCAL': { name: '2findlocal', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-89.svg' },
			TOMTOM: { name: 'TomTom', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-93.svg' },
			EXTERNALFIRSTPARTY: { name: 'External First Party', icon: '' },
			YELPENTERPRISE: { name: 'Yelp Enterprise', icon: '' },
			MYLOCALSERVICES: {
				name: 'My Local Services',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-95.svg',
			},
			N49CA: { name: 'n49', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-100.svg' },
			YANDEX: { name: 'Yandex', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-136.svg' },
			CYLEX: { name: 'Cylex', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-135.svg' },
			IBEGIN: { name: 'iBegin', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-163.svg' },
			IGLOBAL: { name: 'iGlobal', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-159.svg' },
			CREDIBILITYREVIEW: {
				name: 'Credibility Review',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-178.svg',
			},
			INSIDERPAGES: { name: 'Insider Pages', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-187.svg' },
			LOCALSTACK: { name: 'LocalStack', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-184.svg' },
			YALWA: { name: 'Yalwa', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-209.svg' },
			BROWNBOOKNET: { name: 'Brownbook.net', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-214.svg' },
			BIZWIKICOM: { name: 'Bizwiki.com', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-219.svg' },
			SOLEO: { name: 'Soleo', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-223.svg' },
			AROUNDME: { name: 'AroundMe', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-251.svg' },
			HOTFROG: { name: 'HotFrog', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-258.svg' },
			EZLOCAL: { name: 'EZlocal', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-272.svg' },
			FIRSTPARTY: { name: 'First Party', icon: '' },
			LOCALDATABASE: { name: 'LocalDatabase', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-304.svg' },
			PUBLICREPUTATION: {
				name: 'pr.business',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-310.svg',
			},
			FINDOPEN: { name: 'Find Open', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-311.svg' },
			TRIPADVISORREVIEWS: {
				name: 'TripAdvisor',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-312.svg',
			},
			CKMAPS: { name: 'CK Map', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-314.svg' },
			UBER: { name: 'Uber', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-318.svg' },
			ZOMATO: { name: 'Zomato', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-337.svg' },
			POSTMATES: { name: 'Postmates', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-338.svg' },
			YELPKNOWLEDGE: { name: 'Yelp Knowledge', icon: '' },
			BAIDUGLOBAL: { name: 'Baidu', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-348.svg' },
			BANKSCOM: { name: 'Banks.com', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-360.svg' },
			DUNANDBRADSTREET: {
				name: 'D\u0026B Database',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-363.svg',
			},
			FEIZHU: { name: 'Fliggy', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-364.svg' },
			PITNEYBOWES: { name: 'Pitney Bowes', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-365.svg' },
			PROPERTYCAPSULE: {
				name: 'Property Capsule',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-369.svg',
			},
			LOCALCOM: { name: 'Local.com v2', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-370.svg' },
			TRUSTPILOT: { name: 'TrustPilot', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-379.svg' },
			HOLIDAYCHECK: { name: 'HolidayCheck', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-399.svg' },
			DOORDASH: { name: 'DoorDash', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-406.svg' },
			NEXTDOOR: { name: 'Nextdoor', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-408.svg' },
			OPENTABLE: { name: 'OpenTable', icon: '' },
			MAFENGWO: { name: 'Mafengwo', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-415.svg' },
			TOPRATEDLOCAL: {
				name: 'Top Rated Local',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-416.svg',
			},
			TRIP: { name: 'Trip.com', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-418.svg' },
			RETIREMENTPLANNINGNET: {
				name: 'RetirementPlanning.net',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-423.svg',
			},
			HOSTME: { name: 'HostMe', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-427.svg' },
			CENTRALINDEXUS: {
				name: 'Central Index US',
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-97.svg',
			},
			MAPSTR: { name: 'Mapstr', icon: 'https://www.yext-static.com/cms/spark/1/site-icon-422.svg' },
			DexKnows: { icon: 'https://www.yext-static.com/cms/spark/1/site-icon-248.svg', name: 'DexKnows' },
			Instagram: { icon: 'https://www.yext-static.com/cms/spark/1/site-icon-405.svg', name: 'Instagram' },
			Waze: { icon: 'https://www.yext-static.com/cms/spark/1/site-icon-255.svg', name: 'Waze' },
			'White \u0026 Yellow Pages': {
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-70.svg',
				name: 'White \u0026 Yellow Pages',
			},
			AirYell: { icon: 'https://www.yext-static.com/cms/spark/1/site-icon-69.svg', name: 'AirYell' },
			WiserAdvisor: { icon: 'https://www.yext-static.com/cms/spark/1/site-icon-435.svg', name: 'WiserAdvisor' },
			Allonesearch: { icon: 'https://www.yext-static.com/cms/spark/1/site-icon-233.svg', name: 'Allonesearch' },
			'The Internet Chamber of Commerce': {
				icon: 'https://www.yext-static.com/cms/spark/1/site-icon-232.svg',
				name: 'The Internet Chamber of Commerce',
			},
		},
	},
	Mutations: { UPDATE: 1, RESTORE: 3, DESTROY: 2, COPY: 4, CREATE: 0 },
}
